import styled from 'styled-components'
import { Flex } from 'reflexbox/styled-components'

export const ErrorMessage = styled(Flex)`
  border-radius: 8px;
  background-color: rgba(237, 48, 36, 0.2);
  flex-direction: column;
  padding: 16px;
  margin-bottom: 24px;

  ul {
    padding-left: 20px;
  }

  li {
    color: ${({ theme }) => theme.colors.error};
    opacity: 1;
  }
`
